import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export enum HeaderVersion {
    TRANSPARENT,
    OPAQUE,
}

@Injectable({
    providedIn: "root",
})
export class NavigationService {
    headerVersion$ = new BehaviorSubject<HeaderVersion>(HeaderVersion.TRANSPARENT);
    adminPanel$ = new BehaviorSubject<boolean>(false);

    /**
     * Sets the header version
     * @param ver - version of the header
     */
    setHeaderVersion(ver: HeaderVersion) {
        this.headerVersion$.next(ver);
    }

    /**
     * Sets the adminPanel$ subject
     * @param isAdminPanel - is accessed from admin panel
     */
    isAdminPanel(isAdminPanel: boolean): void {
        this.adminPanel$.next(isAdminPanel);
    }
}
